export default __webpack_public_path__ + "static/security-bee-3fd9b1a4a2db403fc9c14d9667b3056e.png";